export default __webpack_public_path__ + "static/media/squares1300.cf1c4f50.jpg";